const isLocationFromOldCE = (location) => {
  if (!location) return false;
  if (location.pathname === '/login') {
    if (!location.search) return false;
    else {
      const params = new URLSearchParams(location.search); // is this parsed?
      const fromAddon = params.get('fromAddon')
        ? JSON.parse(params.get('fromAddon') as string)
        : false;
      return fromAddon;
    }
  }
  return false;
};

const OldCEHelper = {
  isLocationFromOldCE,
};

export default OldCEHelper;
